/* ============================================================================
   OTF — the path to the sale.  2026-10-02 (Bu Site)
   CEO, 1 Oct: "The site is laggy… Motion graphics are not smooth enough
   especially adding to the bag one. Some of the products are not even opening
   at all and sends to the home page." 2 Oct: "let's start applying the fixes
   and solutions from before and use design A."

   WHY THIS IS A SEPARATE FILE AND NOT AN EDIT TO fluid-motion.js
   -------------------------------------------------------------
   Same reason as fluid-rv-sheet.js, fluid-sub.js, otf-sheet-locale.js,
   otf-slot-cutoff.js and otf-address-skip.js: the theme copy of
   fluid-motion.js (170,828 b) is not what the CDN serves (106 KB minified),
   so a hand edit cannot be checksum-proven. Everything here attaches from
   the OUTSIDE through DOM observation, capture-phase listeners and a fetch
   wrapper, and every piece degrades to what the site did before if it fails.

   WHAT IT DOES
   ------------
   1. BACK CLOSES THE LAYER. fluid-motion.js never writes a history entry, so
      the phone's back gesture over an open product sheet left the whole page
      (reproduced 1 Oct: Back after opening a sheet lands on / or outside the
      site). One entry is pushed when the first layer opens (product sheet,
      search, order sheet, page sheet, gallery, bag); popstate closes the top
      layer through the theme's own exits (the bag scrim click, the Escape
      handler); when the customer closes a layer by its X instead, the entry
      is taken back silently. Nested layers simply push again, so Back peels
      them one at a time.
   2. ADD TO BAG ANSWERS THE TAP. fluid-motion.js posts /cart/add.js, then
      refetches /cart.js, and only THEN vibrates, flies the photo and closes
      the sheet - measured 0.8 to 2.4 s of nothing on a throttled phone. Now
      the tap itself vibrates, flies the photo (a GPU transform, one element),
      pops the bag count and, in the sheet, closes it 420 ms later. The
      network still runs underneath and the real count overwrites the
      optimistic one when it lands. If /cart/add.js fails, a toast says so
      and the count is re-read - before, a failed add was silent.
   3. CARDS ARE LINKS. snippets/fluid-gcard.liquid now renders <a href> cards;
      fluid-sub.js already cancels their navigation so the sheet opens as
      before. On the product page there is no sheet listener (the related row
      was a row of dead <button>s), so here the tap navigates.
   4. "ASK US ABOUT THIS BOUQUET" in the product sheet. The sheet is built in
      JS, so the WhatsApp line is appended on insertion with the bouquet's
      name in the message. Design A moved WhatsApp out of the floating layer
      and into the moments where a question actually arises.
   5. THE BOUQUETS PAGE FILTERS. Occasion circles and the budget switch
      combine (tag1+tag2) and re-render the section in place, the same
      section_id fetch fluid-motion.js uses; the search box filters the loaded
      cards instantly and hands a full search to /search.

   13. A MINIMUM QUANTITY (13 Oct). Products listed in #otf-minq cannot go
       in the bag below their minimum; section 13 has the detail.

   14. THE EVENT PLANNER COUNTS (13 Oct). Centerpieces, side tables and
       sweet tables as numbers, in the recap and the WhatsApp message.

   15. THE EVENTS SHEET SWITCH (13 Oct). The occasion segments on the
       rebuilt Events page.

   16. THE TAB BAR COMES BACK AT THE TOP (23 Oct). A fast fling or an instant
       jump to the top could leave the bar tucked away; section 16 has why.

   Strings come from #otf-path-strings in sections/fluid-bar.liquid - no
   customer-facing English lives here.
   ========================================================================= */
(function () {
  'use strict';
  if (!document.querySelector || !window.MutationObserver) return;

  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STR = document.getElementById('otf-path-strings');
  function T(k, fb) { var v = STR && STR.getAttribute('data-' + k); return (v && v.trim()) || fb; }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function buzz(ms) { try { if (navigator.vibrate && !REDUCE) navigator.vibrate(ms); } catch (e) {} }

  /* ---------------- 1. Back closes the layer ---------------- */
  var LAYERS = '.fluid-sheet, .fluid-srch, .fluid-ord, .fluid-gal, .fluid-bag.up, .otf-osheet.is-up, .otf-ss.on';
  var pushed = false, ignorePop = false;
  function layerOpen() { return !!document.querySelector(LAYERS); }
  function closeTop() {
    var os = document.querySelector('.otf-osheet.is-up .os-x');
    if (os) { os.click(); return true; }
    var bag = document.querySelector('.fluid-bag.up');
    if (bag) { var bs = document.querySelector('.fluid-bscrim'); if (bs) { bs.click(); return true; } }
    if (document.querySelector('.otf-ss.on') && window.otfSearchClose) { window.otfSearchClose(); return true; }
    if (document.querySelector('.fluid-sheet, .fluid-srch, .fluid-ord, .fluid-gal')) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
      return true;
    }
    return false;
  }
  function syncHistory() {
    var open = layerOpen();
    if (open && !pushed) {
      pushed = true;
      try { history.pushState({ otfLayer: 1 }, '', location.href); } catch (e) { pushed = false; }
    } else if (!open && pushed) {
      pushed = false;
      if (history.state && history.state.otfLayer) { ignorePop = true; try { history.back(); } catch (e) { ignorePop = false; } }
    }
  }
  addEventListener('popstate', function () {
    if (ignorePop) { ignorePop = false; return; }
    if (pushed) { pushed = false; closeTop(); }
  });
  addEventListener('pageshow', function () { pushed = false; });
  document.addEventListener('otfsearch', function () { setTimeout(syncHistory, 0); });

  /* ---------------- 2. add to bag answers the tap ---------------- */
  var count = document.querySelector('.fluid-bagcount');
  var stickyFrom = null;   /* set by the sticky add while it presses the real button */
  function bump(n) {
    if (!count) return;
    var cur = parseInt(count.textContent, 10) || 0;
    count.textContent = String(cur + n);
    count.classList.remove('otf-pop'); void count.offsetWidth; count.classList.add('otf-pop');
    setTimeout(function () { count.classList.remove('otf-pop'); }, 500);
  }
  function resync() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (count && c && typeof c.item_count === 'number') count.textContent = c.item_count ? String(c.item_count) : '';
    }).catch(function () {});
  }
  var toastEl = null, toastT = 0;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'otf-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }
  function flight(from, src) {
    if (REDUCE || !count || !src) return;
    var a = from.getBoundingClientRect(), b = count.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var img = document.createElement('img');
    img.className = 'otf-fly'; img.src = src; img.alt = '';
    var x0 = a.left + a.width / 2 - 27, y0 = a.top - 14;
    img.style.transform = 'translate3d(' + x0 + 'px,' + y0 + 'px,0) scale(1)';
    img.style.setProperty('--dx', ((b.left + b.width / 2 - 27) - x0) + 'px');
    img.style.setProperty('--dy', ((b.top + b.height / 2 - 27) - y0) + 'px');
    document.body.appendChild(img);
    requestAnimationFrame(function () { requestAnimationFrame(function () { img.classList.add('go'); }); });
    setTimeout(function () { if (img.parentNode) img.parentNode.removeChild(img); }, 760);
  }
  function restoreLabel(btn, saved) {
    /* fluid-motion.js writes the literal "Add to Bag" back after its own
       "Added" - in English on /ar too. Put the rendered label back. */
    var n = 0, t = setInterval(function () {
      if (++n > 30 || !btn.isConnected) { clearInterval(t); return; }
      if (btn.textContent === 'Add to Bag' && saved && saved !== 'Add to Bag') btn.textContent = saved;
    }, 300);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.fluid-add, .fluid-pdp-add') : null;
    if (!btn || btn.disabled || btn.closest('[disabled]')) return;
    var sheet = btn.closest('.fluid-sheet'), pdp = btn.closest('.fluid-pdp');
    var host = sheet || pdp; if (!host) return;
    var qv = host.querySelector('.qv'); var qty = parseInt(qv ? qv.textContent : '1', 10) || 1;
    var tops = host.querySelectorAll('[data-topper]:checked').length;
    var img = sheet ? host.querySelector('.dphoto') : host.querySelector('.fluid-pdp-shot');
    buzz(12);
    /* bump first: an empty count badge is display:none and has no box to fly to */
    bump(qty + tops);
    flight(stickyFrom || btn, img && img.currentSrc ? img.currentSrc : (img && img.src));
    document.body.classList.add('otf-flew');
    setTimeout(function () { document.body.classList.remove('otf-flew'); }, 10000);
    var saved = btn.textContent;
    btn.classList.add('otf-added');
    btn.textContent = T('added', 'Added');
    if (sheet) {
      setTimeout(function () {
        var x = sheet.querySelector('.fluid-close');
        if (x && sheet.isConnected && !sheet.classList.contains('otf-closing')) { sheet.classList.add('otf-closing'); x.click(); }
      }, 420);
    } else {
      setTimeout(function () { btn.classList.remove('otf-added'); }, 1400);
      restoreLabel(btn, saved);
    }
  }, true);

  /* the fetch wrapper: a failed add is said out loud, and the count re-read */
  if (typeof window.fetch === 'function' && !window.__otfPathFetch) {
    window.__otfPathFetch = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = nativeFetch.call(this, input, init);
      if (url.indexOf('/cart/add.js') > -1) {
        p.then(function (r) { if (!r.ok) { toast(T('addfail', 'That did not go in the bag. Please try again.')); resync(); } },
               function () { toast(T('addfail', 'That did not go in the bag. Please try again.')); resync(); });
      }
      return p;
    };
  }

  /* ---------------- the bar highlights the page it is on ----------------
     fluid-motion.js dispatches fluidtab('shop') for /collections, /products
     and /search, then its own boot runs setActive('home') in a later
     animation frame and wins - so the bar always lit Home. Say it again
     after that frame. */
  (function () {
    var p = location.pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    if (!/^\/(collections|products|search)/.test(p) || document.querySelector('.fluid-home')) return;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      document.dispatchEvent(new CustomEvent('fluidtab', { detail: { name: 'shop' } }));
    }); });
  })();

  /* ---------------- the Bouquets button blooms on tap ----------------
     The raised lotus holds the link for 260 ms while the petals open and a
     ripple leaves the button (fluid-nav.css .go), then navigates. Plain taps
     only; a long-press, a middle click or a modifier key keeps the link. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.otf-bloom') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    if (a.classList.contains('go')) { e.preventDefault(); return; }
    e.preventDefault();
    a.classList.add('go'); buzz(10);
    var href = a.href;
    setTimeout(function () { if (window.fluidLoad) window.fluidLoad(true); location.href = href; }, REDUCE ? 0 : 260);
    setTimeout(function () { a.classList.remove('go'); }, 1200);
  });

  /* ---------------- 3. cards are links ---------------- */
  var pdpPage = document.querySelector('.fluid-page.fluid-pdp');
  if (pdpPage) document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var a = e.target && e.target.closest ? e.target.closest('a.fluid-gcard') : null;
    if (!a || !pdpPage.contains(a) || a.hasAttribute('data-sub')) return;
    /* fluid-sub.js cancelled the navigation in capture; nothing opens a
       sheet on this page, so follow the link ourselves. */
    if (window.fluidLoad) window.fluidLoad(true);
    location.href = a.href;
  });

  /* ---------------- 4. ask us, in the sheet ---------------- */
  var WA = 'https://wa.me/96599548711';
  function askLink(name, cls) {
    var a = document.createElement('a');
    a.className = 'otf-ask' + (cls ? ' ' + cls : '');
    a.target = '_blank'; a.rel = 'noopener';
    var msg = T('askmsg', 'Hi, I have a question about');
    a.href = WA + (name ? '?text=' + encodeURIComponent(msg + ' ' + name) : '');
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20l1.4-4.2A8 8 0 1 1 8.2 18.6z"/></svg><span>' + esc(T('ask', 'Ask us about this bouquet on WhatsApp')) + '</span>';
    return a;
  }
  function dressSheet(el) {
    dressGallery(el);
    if (el.querySelector('.otf-ask')) return;
    var row = el.querySelector('.fluid-drow'); if (!row) return;
    var nm = el.querySelector('.fluid-dname');
    var cd = document.createElement('p'); cd.className = 'otf-cd'; cd.setAttribute('data-otf-cd', ''); cd.hidden = true; cd.innerHTML = '<i aria-hidden="true"></i><span></span>';
    row.parentNode.insertBefore(cd, row.nextSibling);
    row.parentNode.insertBefore(askLink(nm ? nm.textContent.trim() : '', 'in-sheet'), cd.nextSibling);
    cdTick();
  }

  /* ---------------- 6. the swipe galleries ----------------
     CEO (2 Oct, evening): "make it a swipable kind of gallery... the products
     they can swipe from outside without having to enter the product".
     The rails are native scroll-snap (fluid-gcard.liquid, fluid-product.liquid,
     and here for the quick sheet); this code only keeps the dots in step,
     carries the swiped photo into the sheet, and turns Gallery into an
     expand icon that opens fluid-motion's pinch-zoom viewer. */
  var RTL = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl' ||
    getComputedStyle(document.documentElement).direction === 'rtl';
  var EXPAND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5"/></svg>';
  function galLabel() { var h = document.querySelector('[data-t-gallery]'); return (h && h.getAttribute('data-t-gallery')) || 'Gallery'; }
  function swIndex(sc) { var w = sc.clientWidth || 1; return Math.max(0, Math.round(Math.abs(sc.scrollLeft) / w)); }
  /* the slides after the first carry data-src only (3 Oct: loading="lazy"
     fetched every slide beside a visible card, 194 images on the home page
     instead of 105). They get their src on the first touch of their rail. */
  function swLoad(sc) {
    if (!sc || sc._otfLoaded) return;
    sc._otfLoaded = true;
    var ims = sc.querySelectorAll('img[data-src]');
    for (var i = 0; i < ims.length; i++) {
      var im = ims[i], ss = im.getAttribute('data-srcset');
      if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-srcset'); }
      im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src');
    }
  }
  function swTouch(e) { var sc = e.target && e.target.closest ? e.target.closest('.otf-swipe') : null; if (sc) swLoad(sc); }
  document.addEventListener('pointerdown', swTouch, { capture: true, passive: true });
  document.addEventListener('touchstart', swTouch, { capture: true, passive: true });
  function swSync(sc) {
    var i = swIndex(sc), host = sc.parentNode;
    var dots = host && host.querySelector('.otf-cdots, .otf-pgdots, .otf-sgdots');
    if (dots) { var ds = dots.children; for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('on', k === i); }
    var card = sc.closest ? sc.closest('.fluid-gcard') : null;
    if (card) {
      var sl = sc.children[i];
      if (sl && sl.getAttribute('data-img')) card.setAttribute('data-img', sl.getAttribute('data-img'));
      card.setAttribute('data-otf-idx', String(i));
    }
  }
  document.addEventListener('scroll', function (e) {
    var sc = e.target;
    if (!sc || !sc.classList || !sc.classList.contains('otf-swipe')) return;
    swLoad(sc);
    if (sc._otfRaf) return;
    sc._otfRaf = true;
    requestAnimationFrame(function () { sc._otfRaf = false; swSync(sc); });
  }, true);
  function swGo(sc, i, smooth) {
    var w = sc.clientWidth, x = i * w * (RTL ? -1 : 1);
    if (smooth && !REDUCE && sc.scrollTo) { try { sc.scrollTo({ left: x, behavior: 'smooth' }); return; } catch (e) {} }
    sc.scrollLeft = x;
  }
  /* the product page: a tap on the photo opens the viewer; desktop arrows step */
  var pg = document.querySelector('[data-otf-pg]');
  if (pg) {
    /* the rest of the product's photos: after the page is in and has sat
       idle, so they are ready for the swipe without racing the first photo */
    (function () {
      function later() { setTimeout(function () { swLoad(pg); }, 1500); }
      if (document.readyState === 'complete') later(); else addEventListener('load', later);
    })();
    pg.addEventListener('click', function () {
      var b = document.querySelector('button.fluid-pdp-gal'); if (b) b.click();
    });
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-otf-pgstep]') : null;
      if (!a) return;
      e.preventDefault(); e.stopPropagation();
      var n = pg.children.length, i = swIndex(pg) + parseInt(a.getAttribute('data-otf-pgstep'), 10);
      swGo(pg, Math.max(0, Math.min(n - 1, i)), true);
    }, true);
  }
  /* the quick sheet: once it is open and the product has arrived, the head
     gets the same rail over the photo motion painted, starting on the photo
     the card was showing when it was tapped */
  var lastCard = null;
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('.fluid-gcard') : null;
    if (c) lastCard = c;
  }, true);
  function dressGallery(el) {
    var gb = el.querySelector('.fluid-galbtn');
    if (gb && !gb.classList.contains('otf-pgx')) { gb.classList.add('otf-pgx'); gb.setAttribute('aria-label', galLabel()); gb.innerHTML = EXPAND; }
    var head = el.querySelector('.dhead'); if (!head || head.querySelector('.otf-sg')) return;
    var tries = 0;
    (function wait() {
      if (!el.isConnected) return;
      var imgs = el._gimgs;
      if (!imgs || !el.classList.contains('opened')) { if (tries++ < 60) setTimeout(wait, 100); return; }
      if (imgs.length < 2 || head.querySelector('.otf-sg')) return;
      var n = Math.min(imgs.length, 12), h = '', d = '', i;
      for (i = 0; i < n; i++) {
        h += '<div class="otf-sgslide"><img class="dphoto" ' + (i ? 'data-src' : 'src') + '="' + esc(String(imgs[i]).replace('width=1800', 'width=900')) + '" alt=""' + (i ? ' decoding="async"' : '') + '></div>';
        d += '<i' + (i ? '' : ' class="on"') + '></i>';
      }
      var sg = document.createElement('div'); sg.className = 'otf-sg otf-swipe'; sg.innerHTML = h;
      var dots = document.createElement('div'); dots.className = 'otf-sgdots'; dots.innerHTML = d;
      var ph = head.querySelector('.dphoto');
      head.insertBefore(sg, ph ? ph.nextSibling : head.firstChild);
      head.appendChild(dots);
      head.classList.add('otf-hasgal');
      var start = 0;
      if (lastCard && lastCard.getAttribute('data-handle') === el.getAttribute('data-handle')) start = parseInt(lastCard.getAttribute('data-otf-idx') || '0', 10) || 0;
      if (start > 0 && start < n) { swLoad(sg); swGo(sg, start, false); }
      swSync(sg);
    })();
  }

  /* ---------------- the one observer ---------------- */
  var bag = document.querySelector('.fluid-bag');
  var osheet = document.querySelector('.otf-osheet');
  var mo = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var added = recs[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && n.classList && n.classList.contains('fluid-sheet')) dressSheet(n);
      }
    }
    syncHistory();
    document.body.classList.toggle('otf-layer', layerOpen());
  });
  mo.observe(document.body, { childList: true });
  if (bag) mo.observe(bag, { attributes: true, attributeFilter: ['class'] });
  if (osheet) mo.observe(osheet, { attributes: true, attributeFilter: ['class'] });

  /* ---------------- 7. the live countdown (CEO pick 2, 2 Oct night) ----------------
     The next same-day window and the time left to order for it, in Kuwait
     time, from the last-order times the editor holds in #fl-slot-cuts
     (13:00 for 12-3, 16:00 for 3-6, 21:00 for 6-9; otf-slot-cutoff.js is the
     authority on those rules). After the last cut: tomorrow's first window.
     Ticks every 20 s on every [data-otf-cd] on the page. */
  var CUTS = (function () {
    var el = document.getElementById('fl-slot-cuts');
    var raw = (el && el.getAttribute('data-cuts')) || '';
    var parts = raw.split(',').map(function (x) { return x.trim(); });
    var out = [], i, m;
    for (i = 0; i < 3; i++) {
      m = /^(\d{1,2}):(\d{2})$/.exec(parts[i] || '');
      out.push(m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : [13 * 60, 16 * 60, 21 * 60][i]);
    }
    return out;
  })();
  var WINDOWS = T('cd-w', '12 to 3 PM|3 to 6 PM|6 to 9 PM').split('|');
  var AR = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  function kwNow() { try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kuwait' })); } catch (e) { return new Date(); } }
  function arDur(h, m) {
    /* Kuwaiti: ساعة / ساعتين / 3 ساعات / 11 ساعة; دقيقة / دقيقتين / 3 دقايق / 11 دقيقة */
    function u(n, one, two, few, many) { return n === 1 ? one : n === 2 ? two : (n >= 3 && n <= 10) ? n + ' ' + few : n + ' ' + many; }
    var hs = h ? u(h, 'ساعة', 'ساعتين', 'ساعات', 'ساعة') : '';
    var ms = m ? u(m, 'دقيقة', 'دقيقتين', 'دقايق', 'دقيقة') : '';
    return hs && ms ? hs + ' و' + ms : (hs || ms);
  }
  function cdText() {
    var now = kwNow(), mins = now.getHours() * 60 + now.getMinutes();
    var i;
    for (i = 0; i < CUTS.length; i++) {
      if (mins < CUTS[i]) {
        var left = CUTS[i] - mins, h = Math.floor(left / 60), m = left % 60, dur;
        if (AR) dur = arDur(h, m);
        else dur = h ? T('cd-hm', '_H_h _M_m').replace('_H_', h).replace('_M_', m) : T('cd-m', '_M_ min').replace('_M_', m);
        var soon = left <= 45;
        return { cls: soon ? 'soon' : '', html: esc(T(soon ? 'cd-soon' : 'cd-today', 'Order in _T_ · arrives today, _W_')).replace('_T_', '<b>' + esc(dur) + '</b>').replace('_W_', esc(WINDOWS[i] || '')) };
      }
    }
    return { cls: 'tmrw', html: esc(T('cd-tmrw', 'Order now · arrives tomorrow, _W_')).replace('_W_', esc(WINDOWS[0] || '')) };
  }
  function cdTick() {
    var els = document.querySelectorAll('[data-otf-cd]'); if (!els.length) return;
    var t = cdText();
    for (var i = 0; i < els.length; i++) {
      var sp = els[i].querySelector('span'); if (sp) sp.innerHTML = t.html;
      els[i].className = 'otf-cd' + (t.cls ? ' ' + t.cls : '');
      els[i].hidden = false;
    }
  }
  cdTick(); setInterval(cdTick, 20000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) cdTick(); });

  /* ---------------- 8. complete the gift, in the bag (CEO pick 3) ----------------
     The rail is rendered by fluid-bar.liquid inside the bag. It shows when the
     bag holds something; the toppers already in are ticked; one tap adds one
     (count bumps, image flies, the bag repaints through fluidOpenBag). */
  var cg = document.querySelector('[data-otf-cg]');
  if (cg) (function () {
    var items = cg.querySelectorAll('.otf-cg-item');
    function paint(cart) {
      var inBag = {}, any = false, j;
      if (cart && cart.items) for (j = 0; j < cart.items.length; j++) { inBag[String(cart.items[j].variant_id)] = true; any = true; }
      for (j = 0; j < items.length; j++) {
        var on = !!inBag[items[j].getAttribute('data-vid')];
        items[j].classList.toggle('in', on);
        items[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      cg.hidden = !any;
    }
    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }
    document.addEventListener('fluidbag', function (e) { if (e.detail && e.detail.open) refresh(); });
    cg.addEventListener('click', function (e) {
      var it = e.target && e.target.closest ? e.target.closest('.otf-cg-item') : null;
      if (!it || it.classList.contains('busy') || it.classList.contains('in')) return;
      var vid = parseInt(it.getAttribute('data-vid'), 10); if (!vid) return;
      it.classList.add('busy'); it.classList.add('in'); buzz(8); bump(1);
      var im = it.querySelector('img'); flight(im || it, it.getAttribute('data-img'));
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { it.classList.remove('busy'); if (window.fluidOpenBag) window.fluidOpenBag(); else refresh(); })
        .catch(function () { it.classList.remove('busy'); it.classList.remove('in'); resync(); });
    });
  })();

  /* ---------------- 8b. the bag scrolls inside its sheet (CEO, 3 Oct) ----------------
     fluid-motion.js starts the sheet drag on any pointerdown in the bag. While
     the scroll box is scrolled, that drag must not start, or a pull to read
     the top of the bag closes it. At the very top the pull still passes
     through, so the old gesture (pull down to close) is kept. */
  var bsc = document.querySelector('[data-otf-bagscroll]');
  if (bsc) (function () {
    var bagEl = bsc.closest('.fluid-bag');
    /* the sheet drag never starts inside the scroll box (the browser owns
       vertical touches here, and a half-started drag only jiggled the sheet) */
    bsc.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    /* ...but the old gesture is kept by hand: a clear pull DOWN while the box
       sits at its top closes the bag, through the scrim the motion script
       already listens to */
    var t0 = null;
    bsc.addEventListener('touchstart', function (e) { t0 = bsc.scrollTop <= 0 && e.touches && e.touches.length === 1 ? e.touches[0].clientY : null; }, { passive: true });
    bsc.addEventListener('touchmove', function (e) {
      if (t0 === null || !e.touches || !e.touches.length) return;
      var dy = e.touches[0].clientY - t0;
      if (dy < -4 || bsc.scrollTop > 0) { t0 = null; return; }
      if (dy > 56) { t0 = null; var sc = document.querySelector('.fluid-bscrim'); if (sc) { buzz(9); sc.click(); } }
    }, { passive: true });
    bsc.addEventListener('touchend', function () { t0 = null; }, { passive: true });
    bsc.addEventListener('touchcancel', function () { t0 = null; }, { passive: true });
    function edge() { bsc.classList.toggle('more', bsc.scrollTop + bsc.clientHeight < bsc.scrollHeight - 2); }
    bsc.addEventListener('scroll', edge, { passive: true });
    /* the HALA goal is inserted before Checkout by otf-offer-goal.js; it
       belongs with the content, not the pinned button */
    function adopt() {
      var g = bagEl && bagEl.querySelector(':scope > .otf-goal');
      if (g) bsc.appendChild(g);
      edge();
    }
    if (bagEl) new MutationObserver(adopt).observe(bagEl, { childList: true, subtree: true });
    document.addEventListener('fluidbag', function (e) { if (e.detail && e.detail.open) { bsc.scrollTop = 0; setTimeout(adopt, 50); setTimeout(edge, 400); } });
    adopt();
  })();

  /* ---------------- 11. the hero as signage (CEO, 3 Oct) ----------------
     The slides are in the card (fluid-home.liquid); this turns them: every
     7 s the next photo slides in over the last (CEO: "kind of like a slide
     show"), the caption swaps, and the card's own data becomes the slide on
     show, so a tap opens that bouquet. Nothing counts the slides (CEO).
     A finger drags it, two arrows move it, and a one-time nudge shows that
     it moves; each holds the clock for a while. It rests while the tab is
     hidden, a full layer is open (not the HALA offer sheet), or the hero is
     off the screen. With reduced motion it does not turn by itself. */
  var hero = document.querySelector('.otf-hero[data-otf-signage]');
  if (hero) (function () {
    var slides = hero.querySelectorAll('.hslide'), n = slides.length; if (n < 2) return;
    var hin = hero.querySelector('.hin'), hname = hero.querySelector('.otf-hname'), hprice = hero.querySelector('.otf-hprice');
    var cur = 0, timer = null, hold = 0, seen = true, drag = 0; /* drag: 0 idle, 1 sideways, -1 the page is scrolling */
    var KEYS = ['handle', 'topok', 'title', 'price', 'note', 'img', 'amb', 'variant', 'available'];
    var tail = (hprice && hprice.textContent.indexOf(String.fromCharCode(183)) > -1) ? hprice.textContent.slice(hprice.textContent.indexOf(String.fromCharCode(183))) : '';
    /* photos arrive two slides ahead of the one on show, never all at once:
       the CEO's set is twenty bouquets (3 Oct) and the home page must not
       fetch twenty photos on load */
    function loadSlide(i) {
      i = (i + n) % n; var im = slides[i].querySelector('img[data-src]'); if (!im) return;
      var ss = im.getAttribute('data-srcset'); if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-srcset'); }
      im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src');
    }
    function ahead(i) { loadSlide(i); loadSlide(i + 1); loadSlide(i + 2); }
    /* each photo slides in over the last: the leaving slide gets .out for the
       length of the move, then goes back to its hidden rest with no
       transition; .back on the card mirrors the move for a backwards swipe */
    var outTimer = null;
    function show(i, fast, dir, fromDrag) {
      i = (i + n) % n; if (i === cur && slides[i].classList.contains('on')) return;
      var sl = slides[i], was = slides[cur];
      ahead(i);
      hero.classList.toggle('back', dir < 0);
      if (!fromDrag) void sl.offsetWidth; /* settle the rest position before the move; after a drag the move must continue from where the finger left it, so no flush */
      for (var j = 0; j < n; j++) if (j !== i) slides[j].classList.remove('out');
      was.classList.remove('on'); was.classList.add('out'); sl.classList.remove('out'); sl.classList.add('on'); cur = i;
      clearTimeout(outTimer); outTimer = setTimeout(function () { was.classList.remove('out'); }, 950);
      for (var k = 0; k < KEYS.length; k++) { var v = sl.getAttribute('data-' + KEYS[k]); if (v !== null) hero.setAttribute('data-' + KEYS[k], v); }
      var u = sl.getAttribute('data-url'); if (u) hero.setAttribute('href', u);
      hero.setAttribute('aria-label', (sl.getAttribute('data-title') || '') + ', ' + (sl.getAttribute('data-price') || ''));
      function words() { if (hname) hname.textContent = sl.getAttribute('data-title') || ''; if (hprice) hprice.textContent = (sl.getAttribute('data-price') || '') + (tail ? ' ' + tail : ''); }
      if (fast || REDUCE || !hin) { words(); return; }
      hin.classList.add('swap'); setTimeout(function () { words(); hin.classList.remove('swap'); }, 320);
    }
    /* the clock pauses behind a full layer, not behind the HALA offer sheet
       (a bottom sheet; the hero stays in view above it and must keep turning) */
    var PAUSE = '.fluid-sheet, .fluid-srch, .fluid-ord, .fluid-gal, .fluid-bag.up, .otf-ss.on';
    function tick() { if (document.hidden || !seen || drag === 1 || document.querySelector(PAUSE) || Date.now() < hold) return; show(cur + 1, false, 1); }
    function start() { if (REDUCE || timer) return; timer = setInterval(tick, 7000); } /* 7 s: calmer beside the slogan and the path bar (3 Oct) */
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; }, { threshold: 0.3 }).observe(hero);
    (function () {
      var done = false;
      function later() { if (done) return; done = true; setTimeout(function () { loadSlide(cur + 1); start(); setTimeout(nudge, 900); }, 1200); } /* one photo ahead at idle, not three: the post-publish measure (3 Oct) showed the home page fetching 290 KB more after load; the turn itself loads two ahead */
      /* the load event waits for every image on the page; a slow one far down
         must not hold the signage, so start by 4 s regardless (CEO: "should
         slide automatically as well within suggested seconds") */
      if (document.readyState === 'complete') later(); else { addEventListener('load', later); setTimeout(later, 4000); }
    })();
    /* the one-time nudge (per session): the photo eases against the run and
       the next one peeks in, so the card says "drag me" once */
    function nudge() {
      if (REDUCE || drag !== 0 || !seen || document.querySelector(PAUSE)) return;
      try { if (sessionStorage.getItem('otf-hero-nudged')) return; sessionStorage.setItem('otf-hero-nudged', '1'); } catch (x) {}
      var nx = slides[(cur + 1) % n]; loadSlide(cur + 1); nx.classList.add('peek'); hero.classList.add('nudge');
      setTimeout(function () { hero.classList.remove('nudge'); nx.classList.remove('peek'); }, 1000);
    }
    /* the arrows: a move, never the sheet, never the link */
    function arrow(el, dir) { if (el) el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hold = Date.now() + 9000; buzz(6); show(cur + dir, false, dir); }); }
    arrow(hero.querySelector('.otf-hnext'), 1); arrow(hero.querySelector('.otf-hprev'), -1);
    /* a finger drags it: the photo follows the finger and the next one comes
       along beside it; let go past a fifth of the width (or with a flick) and
       it commits, otherwise it springs back. Vertical scrolling is untouched:
       the card has touch-action pan-y and the drag only starts on a clearly
       sideways move. Forward is to the left in English and to the right in
       Arabic, like the run itself. */
    var sx = null, sy = null, st = 0, nb = null, ndir = 0, lastDx = 0;
    function width() { return hero.getBoundingClientRect().width || 1; }
    function place(dx) {
      var w = width(), vis = dx < 0 ? 1 : -1; if (AR) vis = -vis;
      if (nb && ndir !== vis) { nb.classList.remove('drag'); nb.style.transform = ''; nb = null; }
      if (!nb) { ndir = vis; nb = slides[(cur + vis + n) % n]; loadSlide(cur + vis); nb.classList.add('drag'); }
      slides[cur].classList.add('drag');
      slides[cur].style.transform = 'translate3d(' + dx + 'px,0,0)';
      nb.style.transform = 'translate3d(' + (dx + (dx < 0 ? w : -w)) + 'px,0,0)';
    }
    function snap() {
      var was = slides[cur], b = nb; nb = null;
      hero.classList.toggle('back', ndir < 0); /* so the neighbour goes home to the side it came from */
      was.classList.add('snap'); was.classList.remove('drag'); was.style.transform = '';
      if (b) { b.classList.add('snap'); b.classList.remove('drag'); b.style.transform = ''; }
      setTimeout(function () { was.classList.remove('snap'); if (b) b.classList.remove('snap'); }, 380);
    }
    function commit(dir) {
      var tgt = (cur + dir + n) % n, sl = slides[tgt], was = slides[cur]; nb = null;
      hold = Date.now() + 9000;
      /* clear the dragged positions and change the classes with no style
         flush between, so the move carries on from under the finger */
      sl.classList.remove('drag'); was.classList.remove('drag'); sl.style.transform = ''; was.style.transform = '';
      show(tgt, false, dir, true);
    }
    hero.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); drag = 0; lastDx = 0;
    }, { passive: true });
    hero.addEventListener('touchmove', function (e) {
      if (sx === null || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (drag === 0) { if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; drag = Math.abs(dx) > Math.abs(dy) ? 1 : -1; if (drag === 1) hold = Date.now() + 9000; }
      if (drag !== 1) return;
      lastDx = dx; place(dx);
    }, { passive: true });
    hero.addEventListener('touchend', function () {
      if (sx === null) return;
      var dx = lastDx, dt = Date.now() - st, d = drag; sx = sy = null; drag = 0;
      if (d !== 1) return;
      var flick = Math.abs(dx) > 24 && dt < 300;
      if (Math.abs(dx) < width() * 0.2 && !flick) { snap(); return; }
      buzz(6); commit(ndir);
    }, { passive: true });
    hero.addEventListener('touchcancel', function () { if (drag === 1) snap(); sx = sy = null; drag = 0; }, { passive: true });
  })();

  /* ---------------- 9. the sticky add, product page (CEO pick 6) ---------------- */
  (function () {
    var pdp = document.querySelector('.fluid-pdp'); if (!pdp) return;
    var real = pdp.querySelector('.fluid-pdp-add'), row = pdp.querySelector('.fluid-pdp-row'); if (!real || !row) return;
    var shot = pdp.querySelector('.fluid-pdp-shot'), name = pdp.querySelector('.fluid-pdp-name'), price = pdp.querySelector('[data-price]');
    var bar = document.createElement('div'); bar.className = 'otf-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = (shot ? '<img src="' + esc(shot.currentSrc || shot.src) + '" alt="">' : '') +
      '<div class="t"><span class="n">' + esc(name ? name.textContent.trim() : '') + '</span><span class="pr"></span></div>' +
      '<button class="otf-sticky-add" type="button"' + (real.disabled ? ' disabled' : '') + '>' + esc(real.textContent.trim()) + '</button>';
    document.body.appendChild(bar);
    var sbtn = bar.querySelector('.otf-sticky-add'), spr = bar.querySelector('.pr');
    var past = false;
    function sync() {
      if (price) spr.textContent = price.textContent.trim();
      var on = past && !layerOpen() && !document.querySelector('.fluid-nav.searching');
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    /* read the row's place on every scroll frame: an observer alone misses
       a fast fling that carries the row from below the screen to above it
       inside one frame (seen in the headless check, 3 Oct) */
    var raf = false;
    function check() {
      raf = false;
      past = row.getBoundingClientRect().bottom < 0;
      sync();
    }
    function onScroll() { if (!raf) { raf = true; requestAnimationFrame(check); } }
    document.addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(onScroll, { threshold: 0 }).observe(row);
    check();
    pdp.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.fluid-var')) setTimeout(sync, 0); });
    new MutationObserver(function () { sync(); if (real.disabled !== sbtn.disabled) sbtn.disabled = real.disabled; }).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
    sbtn.addEventListener('click', function () {
      if (real.disabled) return;
      stickyFrom = bar.querySelector('img') || sbtn;
      real.click();
      stickyFrom = null;
      sbtn.classList.add('otf-added'); var saved = sbtn.textContent; sbtn.textContent = T('added', 'Added');
      setTimeout(function () { sbtn.classList.remove('otf-added'); sbtn.textContent = saved; }, 1400);
    });
  })();

  /* ---------------- 12. Arabic names in the bag (5 Oct) ----------------
     fluid-motion.js builds every bag line from '/cart.js', the store's
     default-language cart, so on /ar a bouquet came out under its English
     name ("Red Fortress") while its own page says "ريد فورتريس". The Arabic
     cart lives at /ar/cart.js and every line carries its cart key in
     data-del, so the name is put right per line from there. The cart page is
     covered too: its first paint is Arabic Liquid, but fluid-motion.js
     redraws it in English after any change. Attached from outside, as the
     theme requires. */
  (function () {
    if (!AR) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/ar/';
    var names = {}, busy = false;
    function apply() {
      var ws = document.querySelectorAll('.fluid-bline-wrap'), miss = false;
      for (var i = 0; i < ws.length; i++) {
        var d = ws[i].querySelector('[data-del]'), n = ws[i].querySelector('.fluid-bln'); if (!d || !n) continue;
        var nm = names[d.getAttribute('data-del')];
        if (nm) { if (n.textContent !== nm) n.textContent = nm; } else miss = true;
      }
      return miss;
    }
    function load() {
      if (busy) return; busy = true;
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        for (var i = 0; i < (c.items || []).length; i++) names[c.items[i].key] = c.items[i].product_title;
      }).catch(function () {}).then(function () { busy = false; apply(); });
    }
    function check() { if (apply()) load(); }
    var mo = new MutationObserver(check), lists = document.querySelectorAll('.fluid-blines');
    for (var i = 0; i < lists.length; i++) mo.observe(lists[i], { childList: true });
    check();
  })();

  /* ---------------- 13. a minimum quantity (CEO, 13 Oct) ----------------
     "Petite garden floral cannot be sold by itself it is minimum 5
     arrangements so create a lock on it so people can't order less than 5
     of it." Shopify has no minimum quantity outside B2B, and every bag write
     lives in fluid-motion.js, which is not edited (header). So the lock is
     here, in three layers:
       a. the steppers on the product page and the quick sheet start at the
          minimum and their minus stops there, with a line saying why;
       b. every /cart/add.js, /cart/change.js and /cart/update.js the theme
          sends is read first and corrected: an add tops the line up to the
          minimum, a change below it (the bag's minus) holds at the minimum,
          and update.js - sent by the order sheet just before checkout -
          lifts any short line, so nothing short reaches payment;
       c. a bag that already holds too few (added before the lock) is lifted
          on page load, with the same toast.
     Which products: #otf-minq in sections/fluid-bar.liquid, as variant:min
     pairs built from handles there. Delete a line there and the lock is gone.
     Not covered: a hand-made /cart/<variant>:<qty> link, which goes straight
     to Shopify's checkout without this theme. */
  var MINQ = {};
  (function () {
    var el = document.getElementById('otf-minq');
    var raw = (el && el.getAttribute('data-min')) || '';
    raw.split(',').forEach(function (p) {
      var b = p.split(':'), v = parseInt(b[0], 10), m = parseInt(b[1], 10);
      if (v && m > 1) MINQ[v] = m;
    });
  })();
  function minOf(id) { return MINQ[parseInt(String(id || '').split(':')[0], 10)] || 0; }
  function minMsg(n) { return T('minqhold', 'This one is ordered in at least _N_.').replace('_N_', n); }
  var hasMin = false; for (var mk in MINQ) if (MINQ.hasOwnProperty(mk)) { hasMin = true; break; }

  if (hasMin) (function () {
    /* a. the steppers */
    function scopeMin(sc) { return sc ? minOf(sc.getAttribute('data-variant')) : 0; }
    function lift(sc) {
      var m = scopeMin(sc); if (!m) return;
      var qv = sc.querySelector('.qv'), plus = sc.querySelector('.fluid-stepper [data-s="1"]');
      if (!qv || !plus) return;
      for (var i = 0; i < 25 && (parseInt(qv.textContent, 10) || 1) < m; i++) {
        var before = qv.textContent; plus.click();
        if (qv.textContent === before) break;   /* the theme has not wired the stepper yet */
      }
      if (!sc.querySelector('.otf-minq')) {
        var row = sc.querySelector('.fluid-pdp-row, .fluid-drow');
        if (row) {
          var p = document.createElement('p'); p.className = 'otf-minq';
          p.textContent = T('minq', 'Minimum order: _N_').replace('_N_', m);
          row.parentNode.insertBefore(p, row.nextSibling);
        }
      }
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.fluid-stepper [data-s="-1"]') : null;
      if (!b) return;
      var sc = b.closest('.fluid-sheet, .fluid-pdp'), m = scopeMin(sc); if (!m) return;
      var qv = sc.querySelector('.qv');
      if (qv && (parseInt(qv.textContent, 10) || 1) <= m) { e.stopPropagation(); e.preventDefault(); toast(minMsg(m)); }
    }, true);
    var pdpEl = document.querySelector('.fluid-pdp');
    function liftPdp() { if (pdpEl) lift(pdpEl); }
    liftPdp(); window.addEventListener('load', liftPdp);
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) for (var j = 0; j < recs[i].addedNodes.length; j++) {
        var n = recs[i].addedNodes[j];
        if (n.nodeType === 1 && n.classList && n.classList.contains('fluid-sheet')) (function (sh) { setTimeout(function () { lift(sh); }, 0); })(n);
      }
    }).observe(document.body, { childList: true });

    /* b. every bag write */
    if (typeof window.fetch !== 'function') return;
    var prevFetch = window.fetch;
    function getCart() {
      return prevFetch.call(window, ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }
    function have(cart, vid) {
      var n = 0;
      for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === vid) n += cart.items[i].quantity;
      return n;
    }
    function fix(kind, d, cart) {
      var said = 0, i, it;
      if (kind === 'add') {
        var items = d.items || (d.id ? [d] : []);
        for (i = 0; i < items.length; i++) {
          it = items[i]; var m = minOf(it.id); if (!m) continue;
          var vid = parseInt(it.id, 10), q = parseInt(it.quantity, 10) || 1, h = have(cart, vid);
          if (h + q < m) { it.quantity = m - h; said = m; }
        }
      } else if (kind === 'change') {
        var line = null;
        if (d.line) line = cart.items[parseInt(d.line, 10) - 1] || null;
        else for (i = 0; i < cart.items.length; i++) {
          it = cart.items[i];
          if (it.key === String(d.id) || (String(d.id).indexOf(':') < 0 && it.variant_id === parseInt(d.id, 10))) { line = it; break; }
        }
        var lm = line ? minOf(line.variant_id) : 0, nq = parseInt(d.quantity, 10);
        if (lm && nq > 0 && nq < lm) { d.quantity = lm; said = lm; }
      } else {
        var up = d.updates;
        if (up && !Array.isArray(up)) for (var k in up) {
          var um = minOf(k), uq = parseInt(up[k], 10);
          if (um && uq > 0 && uq < um) { up[k] = um; said = um; }
        }
        for (i = 0; i < cart.items.length; i++) {
          it = cart.items[i]; var cm = minOf(it.variant_id);
          if (cm && it.quantity < cm && !(up && (it.key in up || String(it.variant_id) in up))) {
            d.updates = d.updates || {}; d.updates[it.key] = cm; said = cm;
          }
        }
      }
      if (said) toast(minMsg(said));
      return d;
    }
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var m = /\/cart\/(add|change|update)\.js/.exec(url);
      var body = init && typeof init.body === 'string' ? init.body : null;
      if (!m || !body) return prevFetch.apply(this, arguments);
      var d; try { d = JSON.parse(body); } catch (e) { return prevFetch.apply(this, arguments); }
      var kind = m[1], self = this, args = arguments;
      if (kind === 'add') {
        var items = d.items || (d.id ? [d] : []), touch = false;
        for (var i = 0; i < items.length; i++) if (minOf(items[i].id)) touch = true;
        if (!touch) return prevFetch.apply(self, args);
      }
      if (kind === 'change' && !d.line && !minOf(d.id)) return prevFetch.apply(self, args);
      return getCart().then(function (cart) {
        var ni = {}; for (var k in init) ni[k] = init[k];
        ni.body = JSON.stringify(fix(kind, d, cart));
        return prevFetch.call(self, input, ni);
      }, function () { return prevFetch.apply(self, args); });
    };

    /* c. a bag that already holds too few - only when the bag count says it
       holds anything, and after the page has settled */
    if (count && !(parseInt(count.textContent, 10) || 0)) return;
    setTimeout(function () { getCart().then(function (cart) {
      var ups = {}, n = 0, said = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i], m = minOf(it.variant_id);
        if (m && it.quantity < m) { ups[it.key] = m; n++; said = m; }
      }
      if (!n) return;
      return prevFetch.call(window, ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: ups }) })
        .then(function () { toast(minMsg(said)); resync(); });
    }).catch(function () {}); }, 2500);
  })();

  /* ---------------- 14. the event planner counts (CEO, 13 Oct) ----------------
     "We need the event planner to be upgraded for customers to customize how
     many centerpieces and side tables and sweet table arrangements. It will
     help to govern a quotation." The planner is built by fluid-motion.js
     (buildEvent), which is not edited, so this attaches from outside: when
     the planner layer appears, a "How many" group with three steppers goes
     in after "What you need"; the recap card gets the three rows back every
     time the theme redraws it; and the WhatsApp message the Send button
     opens gets the three lines appended through a window.open wrapper. The
     old budget note that quoted "Packages start at KD 350" is replaced,
     because there are no packages any more (13 Oct). Strings from
     #otf-path-strings. */
  (function () {
    var CNT = [['cen', 'evcen', 'Centerpieces'], ['side', 'evside', 'Side table arrangements'], ['sweet', 'evsweet', 'Sweet table arrangements']];
    var n = { cen: 0, side: 0, sweet: 0 }, live = null;
    function lbl(k) { for (var i = 0; i < CNT.length; i++) if (CNT[i][0] === k) return T(CNT[i][1], CNT[i][2]); return k; }
    function recapRows(box) {
      if (!box) return;
      var old = box.querySelectorAll('[data-otf-row]');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      var anchor = null, rows = box.querySelectorAll('.frow');
      for (var j = 0; j < rows.length; j++) { var f = rows[j].firstElementChild; if (f && /need|تبون/i.test(f.textContent)) anchor = rows[j]; }
      for (var k = CNT.length - 1; k >= 0; k--) {
        var key = CNT[k][0]; if (!n[key]) continue;
        var r = document.createElement('div'); r.className = 'frow'; r.setAttribute('data-otf-row', '');
        r.innerHTML = '<span>' + esc(lbl(key)) + '</span><span>' + n[key] + '</span>';
        if (anchor) anchor.parentNode.insertBefore(r, anchor.nextSibling); else box.insertBefore(r, box.firstChild);
      }
    }
    function dress(el) {
      if (el.querySelector('.otf-evcnt')) return;
      var needs = el.querySelector('[data-k="needs"]'); var grp = needs && needs.closest('.fluid-ogrp'); if (!grp) return;
      n = { cen: 0, side: 0, sweet: 0 }; live = el;
      var sec = document.createElement('section'); sec.className = 'fluid-ogrp otf-evcnt';
      var h = '<h3>' + esc(T('evhow', 'How many')) + '</h3>';
      for (var i = 0; i < CNT.length; i++) {
        h += '<div class="r"><span>' + esc(T(CNT[i][1], CNT[i][2])) + '</span>' +
          '<div class="fluid-stepper"><button type="button" data-otf-cnt="' + CNT[i][0] + '" data-d="-1" aria-label="' + esc(T('q_less', 'Less')) + '">&minus;</button>' +
          '<span class="qv" data-otf-qv="' + CNT[i][0] + '">0</span>' +
          '<button type="button" data-otf-cnt="' + CNT[i][0] + '" data-d="1" aria-label="' + esc(T('q_more', 'More')) + '">+</button></div></div>';
      }
      h += '<p class="fluid-onote">' + esc(T('evhownote', 'Rough numbers are fine. They help us quote faster.')) + '</p>';
      sec.innerHTML = h;
      grp.parentNode.insertBefore(sec, grp.nextSibling);
      var notes = el.querySelectorAll('.fluid-onote');
      for (var j = 0; j < notes.length; j++) if (/Packages start/i.test(notes[j].textContent)) notes[j].textContent = T('evquote', 'The quote follows the pieces you pick and the design.');
      var box = el.querySelector('[data-recap]');
      if (box) new MutationObserver(function () { if (!box.querySelector('[data-otf-row]')) recapRows(box); }).observe(box, { childList: true });
      /* "Start another" rebuilds the layer's insides in place: dress it again
         with the counts back at zero; a closed layer forgets them */
      if (!el.hasAttribute('data-otf-evobs')) {
        el.setAttribute('data-otf-evobs', '');
        new MutationObserver(function () {
          if (!el.isConnected) { live = null; return; }
          if (!el.querySelector('.otf-evcnt') && el.querySelector('[data-k="needs"]')) dress(el);
        }).observe(el, { childList: true });
      }
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-otf-cnt]') : null; if (!b || !live) return;
      var k = b.getAttribute('data-otf-cnt'), d = parseInt(b.getAttribute('data-d'), 10);
      n[k] = Math.max(0, Math.min(99, (n[k] || 0) + d));
      var qv = live.querySelector('[data-otf-qv="' + k + '"]'); if (qv) qv.textContent = String(n[k]);
      buzz(5); recapRows(live.querySelector('[data-recap]'));
    });
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) for (var j = 0; j < recs[i].addedNodes.length; j++) {
        var x = recs[i].addedNodes[j];
        if (x.nodeType === 1 && x.classList && x.classList.contains('fluid-flow') && x.getAttribute('aria-label') === 'Plan your event') dress(x);
      }
    }).observe(document.body, { childList: true });
    if (typeof window.open === 'function') {
      var nativeOpen = window.open;
      window.open = function (url) {
        try {
          if (live && live.isConnected && typeof url === 'string' && url.indexOf('wa.me/') > -1 && url.indexOf('text=') > -1 && (n.cen || n.side || n.sweet)) {
            var at = url.indexOf('text=') + 5, txt = decodeURIComponent(url.slice(at)), add = [];
            for (var i = 0; i < CNT.length; i++) if (n[CNT[i][0]]) add.push(lbl(CNT[i][0]) + ': ' + n[CNT[i][0]]);
            url = url.slice(0, at) + encodeURIComponent(txt + String.fromCharCode(10) + add.join(String.fromCharCode(10)));
            arguments[0] = url;
          }
        } catch (err) {}
        return nativeOpen.apply(window, arguments);
      };
    }
  })();

  /* ---------------- 15. the Events sheet occasion switch (13 Oct) ----------------
     sections/fluid-page.liquid is injected as innerHTML in the sheet, so its
     switch is delegated from here: the chosen segment lights and the line
     under it takes that segment's data-p. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-otf-evseg] button') : null; if (!b) return;
    var seg = b.closest('[data-otf-evseg]'), all = seg.querySelectorAll('button');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('on', all[i] === b);
    var p = seg.parentNode.querySelector('[data-otf-evseg-p]'); if (p) p.textContent = b.getAttribute('data-p') || '';
    buzz(5);
  });

  /* ---------------- 16. the tab bar comes back at the top (23 Oct) ----------------
     fluid-motion.js skips any scroll step over 200 px, its own "back near the
     top, show the bar" check included. So a fast fling or an instant jump to the
     top could leave the bar tucked away with nothing left to scroll up to. When a
     real scroll lands near the top with the bar still moved, replay one quiet
     scroll event on the next frame: the motion script then reads a zero step at
     the top and brings the bar back with its own spring. */
  (function () {
    var nav = document.querySelector('.fluid-nav'); if (!nav) return;
    var raf = 0;
    addEventListener('scroll', function (e) {
      if (!e.isTrusted || raf || scrollY < 0 || scrollY >= 70) return;
      var m = /,\s*(-?[\d.]+)px/.exec(nav.style.transform || '');
      if (!nav.classList.contains('gone') && !(m && +m[1] > 1)) return;
      raf = requestAnimationFrame(function () { raf = 0; dispatchEvent(new Event('scroll')); });
    }, { passive: true });
  })();

  /* ---------------- 5. the bouquets page ---------------- */
  var cf = document.querySelector('[data-otf-cf]');
  var coll = document.querySelector('.fluid-coll');
  if (cf && coll) (function () {
    var grid = coll.querySelector('.fluid-grid');
    var moreWrap = coll.querySelector('.fluid-more-wrap');
    var countEl = coll.querySelector('.fluid-pcount');
    var sid = coll.getAttribute('data-sid');
    var base = cf.getAttribute('data-base') || coll.getAttribute('data-base') || location.pathname;
    var q = cf.querySelector('[data-otf-q]');
    var hint = cf.querySelector('[data-otf-qhint]');
    var st = { occ: '', band: '', busy: false };
    var onOcc = cf.querySelector('[data-otf-occ] .on'), onBand = cf.querySelector('[data-otf-band] .on');
    if (onOcc) st.occ = onOcc.getAttribute('data-tag') || '';
    if (onBand) st.band = onBand.getAttribute('data-tag') || '';

    function url() {
      var tags = [st.occ, st.band].filter(Boolean).join('+');
      return base.replace(/\/+$/, '') + (tags ? '/' + tags : '');
    }
    function mark(group, tag) {
      var b = cf.querySelectorAll('[data-otf-' + group + '] [data-tag]');
      for (var i = 0; i < b.length; i++) b[i].classList.toggle('on', (b[i].getAttribute('data-tag') || '') === tag);
    }
    function pull(href) {
      var u = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      return fetch(u).then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); }).then(function (t) {
        var box = document.createElement('div'); box.innerHTML = t; return box;
      });
    }
    function apply() {
      if (st.busy) return; st.busy = true;
      var href = url();
      grid.classList.add('swapping');
      pull(href).then(function (box) {
        var ng = box.querySelector('.fluid-grid');
        grid.innerHTML = ng ? ng.innerHTML : '';
        if (moreWrap) {
          var nm = box.querySelector('.fluid-more-wrap');
          if (nm) { moreWrap.innerHTML = nm.innerHTML; moreWrap.hidden = nm.hidden; } else { moreWrap.innerHTML = ''; moreWrap.hidden = true; }
        }
        var nc = box.querySelector('.fluid-pcount');
        if (countEl && nc) countEl.textContent = nc.textContent;
        grid.classList.remove('swapping');
        try { history.replaceState(history.state, '', href); } catch (e) {}
        if (q && q.value) filterCards(q.value);
        st.busy = false;
      }).catch(function () { grid.classList.remove('swapping'); st.busy = false; location.href = href; });
    }
    cf.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tag]'); if (!b) return;
      var group = b.closest('[data-otf-occ]') ? 'occ' : (b.closest('[data-otf-band]') ? 'band' : '');
      if (!group) return;
      var tag = b.getAttribute('data-tag') || '';
      if (st[group] === tag) return;
      st[group] = tag; mark(group, tag); buzz(6); apply();
    });

    /* the search box: instant over the loaded cards, full search on Enter */
    function filterCards(v) {
      var s = v.trim().toLowerCase();
      var wraps = grid.querySelectorAll('.fluid-gwrap'), shown = 0;
      for (var i = 0; i < wraps.length; i++) {
        var c = wraps[i].querySelector('.fluid-gcard');
        var hay = ((c && c.getAttribute('data-title')) || '') + ' ' + (wraps[i].getAttribute('data-tags') || '');
        var ok = !s || hay.toLowerCase().indexOf(s) > -1;
        wraps[i].classList.toggle('hide', !ok);
        if (ok) shown++;
      }
      if (hint) {
        if (s.length >= 2) {
          hint.hidden = false;
          hint.href = ROOT + 'search?q=' + encodeURIComponent(v.trim());
          hint.textContent = T('qall', 'Search the whole shop for “_Q_”').replace('_Q_', v.trim());
        } else hint.hidden = true;
      }
      var none = grid.querySelector('.otf-cf-none');
      if (!shown && s) {
        if (!none) { none = document.createElement('p'); none.className = 'fluid-psub otf-cf-none'; none.style.gridColumn = '1/-1'; none.textContent = T('qnone', 'Nothing here matches. Try the whole shop.'); grid.appendChild(none); }
      } else if (none) none.remove();
    }
    if (q) {
      var deb = 0;
      q.addEventListener('input', function () { clearTimeout(deb); deb = setTimeout(function () { filterCards(q.value); }, 120); });
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && q.value.trim().length >= 2) { e.preventDefault(); location.href = ROOT + 'search?q=' + encodeURIComponent(q.value.trim()); }
      });
    }
  })();
})();
